import { ClickAction } from "modules/clickAction";

export type MarkerClipboardData = {
  id?: string;
  roomId?: string;
  x?: number;
  y?: number;
  width: number;
  height: number;
  locked: boolean;
  freezed: boolean;
  imageUrl: string | null;
  text: string;
  angle?: number;
  clickAction: ClickAction | null;
};

type MarkerEntry = {
  key: string;
  copyData: MarkerClipboardData;
};

const DB_NAME = "marker-clipboard-entries";
const VERSION = 1;
const STORE_NAME = "marker";

const openIndexedDB = (): Promise<IDBDatabase> => {
  return new Promise((resolve, reject) => {
    const request = indexedDB.open(DB_NAME, VERSION);
    request.onupgradeneeded = (event) => {
      const db = (event.target as IDBOpenDBRequest).result;
      if (!db.objectStoreNames.contains(STORE_NAME)) {
        db.createObjectStore(STORE_NAME, { keyPath: "key" });
      }
    };
    request.onsuccess = (event) => {
      resolve((event.target as IDBOpenDBRequest).result);
    };
    request.onerror = reject;
  });
};

const getIndexedDBStore = async (): Promise<IDBObjectStore> => {
  const db = await openIndexedDB();
  const transaction = db.transaction([STORE_NAME], "readwrite");
  return transaction.objectStore(STORE_NAME);
};

const getReadonlyIndexedDBStore = async (): Promise<IDBObjectStore> => {
  const db = await openIndexedDB();
  const transaction = db.transaction([STORE_NAME], "readonly");
  return transaction.objectStore(STORE_NAME);
};

export const writeMarkerIDB = async (value: MarkerEntry): Promise<void> => {
  const objectStore = await getIndexedDBStore();
  return new Promise((resolve, reject) => {
    const req = objectStore.put(value);
    req.onsuccess = () => resolve();
    req.onerror = reject;
  });
};

export const deleteAllMarkerIDB = async (): Promise<void> => {
  const objectStore = await getIndexedDBStore();
  return new Promise((resolve, reject) => {
    const req = objectStore.clear();
    req.onsuccess = () => resolve();
    req.onerror = reject;
  });
};

export const getMarkerByKeyIDB = async (
  key: string
): Promise<MarkerEntry | undefined> => {
  const objectStore = await getReadonlyIndexedDBStore();
  const request = objectStore.get(key);
  return new Promise((resolve, reject) => {
    request.onsuccess = () =>
      resolve(request.result as MarkerEntry | undefined);
    request.onerror = reject;
  });
};
